import { jsxs as t, jsx as n } from "react/jsx-runtime";
import { copyToClipboard as c } from "../../services/utils/index.js";
import { Icon as C } from "../Icon/index.js";
import { CopyButtonContainer as f, CopyButtonText as u, CopyButtonBadge as y } from "./style.js";
import { Copy as d } from "@pelando/fontawesome/icons";
function b({
  children: r,
  disabled: i,
  coupon: p,
  onClick: e,
  className: l,
  copyButtonLabel: a,
  ariaLabelIcon: m
}) {
  return /* @__PURE__ */ t(f, { className: l, children: [
    /* @__PURE__ */ n(u, { children: r }),
    /* @__PURE__ */ t(y, { onClick: (o) => {
      e(), o.preventDefault(), o.stopPropagation(), c(p);
    }, disabled: i, children: [
      /* @__PURE__ */ n(
        C,
        {
          role: "img",
          icon: d,
          "aria-label": m,
          style: { fontSize: "24px" }
        }
      ),
      a
    ] })
  ] });
}
export {
  b as CopyButton
};
